



















import { Vue, Component, Prop } from 'vue-property-decorator';
import * as config from '../config';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from '../store/mutation-types';
import VoteButton from './VoteButton.vue';

const Modules = namespace('JKMX20200807');
@Component({
  components: {
    VoteButton,
  },
})
export default class VoteList extends Vue {
  @Prop() item!: any;
  options = config.OPTHINES;
  button = true;

  @Modules.Mutation(mutationTypes.GET_VOTE) getVote!: (PostLike: any) => void;
  @Modules.Mutation(mutationTypes.UPDATE_VOTE) updateVote!: () => void;
  @Modules.State('votes') votes!: {};
  created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };
  }
  votSuccess(num: string) {
    this.item.votes = num;
    this.updateVote();
    this.button = false;
    setTimeout(() => {
      this.button = true;
    }, 1000);
  }
}
